import { useHistory, useLocation } from '@atlassian/mpac-ui';
import { useCallback, useEffect, useState } from 'react';
export const sortQueryParamKey = 'sort';
export const useSort = () => {
  const history = useHistory();
  const {
    pathname,
    search
  } = useLocation();
  const [selectedSortKey, setSelectedSortKey] = useState('');
  const updateQueryParam = useCallback(sortKey => {
    const queryParams = new URLSearchParams(search);
    queryParams.set(sortQueryParamKey, sortKey);
    history === null || history === void 0 ? void 0 : history.push("".concat(pathname, "?").concat(queryParams));
  }, [history, pathname, search]);
  useEffect(() => {
    const queryParams = new URLSearchParams(search);
    const sortKey = queryParams.get(sortQueryParamKey);
    if (sortKey) {
      setSelectedSortKey(sortKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const queryParams = new URLSearchParams(search);
    const sortKey = queryParams.get(sortQueryParamKey);
    if (sortKey !== selectedSortKey) {
      setSelectedSortKey(sortKey || '');
    }
  }, [search]);
  const onSortOptionSelect = useCallback(sortOption => {
    updateQueryParam(sortOption.value);
    setSelectedSortKey(sortOption.value);
  }, [updateQueryParam]);
  return {
    selectedSortKey,
    onSortOptionSelect,
    setSelectedSortKey
  };
};